const actionTypes = require('../../actionTypes');

// orgStates

module.exports.createOrgStatesAction = (orgStates)=> ({ type: actionTypes.orgStates, payload: new Map(orgStates) })

module.exports.changeOrgStatesState = (previousState, payload)=> Object.assign({}, previousState, { orgStates: payload })


// currentOrgNode

module.exports.createCurrentOrgNodeAction = (selectedOrgNode)=> ({
        type: actionTypes.currentOrgNode,
        payload: selectedOrgNode == null
            ? null
            : Object.assign({}, selectedOrgNode)
    })

module.exports.changeCurrentOrgNodeState = (previousState, payload)=> Object.assign({}, previousState, { currentOrgNode: payload })